import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetArticlePriceListResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'article_price_list': [
                    {
                        'article': {
                            'code': '4233',
                            'name': 'Baguette',
                            'fantasy_name': 'Baguette',
                            'items_amount': 20,
                            'category': 'Panadería Francesa'
                        },
                        'price': {
                            'amount': 5,
                            'currency': 'ARS'
                        }
                    }
                ],
            },
            errors: []
        }
    }

    articlePriceList() {
        return this.content().article_price_list.map(priced_article => {
            return {
                article: this._adaptArticle(priced_article.article),
                price: this._adaptPrice(priced_article.price),
            }
        });
    }

    _adaptArticle(article) {
        return {
            'code': article.code,
            'name': article.name,
            'fantasyName': article.fantasy_name,
            'itemsAmount': article.items_amount,
            'category': article.category.name
        }
    }

    _adaptPrice(price) {
        return {
            'amount': price.amount,
            'currency': price.currency,
        }
    }
}